import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

window['_AMapSecurityConfig'] = {
	securityJsCode: 'f5314f7388e72193ca470c88ac71afd7',
};

createApp(App).use(router).mount('#app');
